
export const styles = {
  container: {
    backgroundColor: 'animate-nature-morph bg-gradient-to-br from-emerald-50/90 via-green-100/85 to-emerald-50/80 bg-size-200',
    minHeight: '250px',
    backdropFilter: 'backdrop-blur-lg',
    position: 'relative',
    overflow: 'hidden'
  },
  header: {
    background: 'bg-emerald-600',
    textColor: 'text-white font-medium',
    border: 'border-b border-emerald-500',
    position: 'relative',
    zIndex: '10'
  },
  avatar: {
    background: 'bg-white bg-opacity-20 backdrop-blur',
        text: 'text-emerald-800',
        border: 'border-2 border-emerald-600',
    boxShadow: 'shadow-lg shadow-emerald-500/20',
    position: 'relative',
    zIndex: '10',
    shape: 'rounded-full aspect-square overflow-hidden'
  },
  messages: {
    bot: {
      background: 'bg-white/90 backdrop-blur transform transition-all duration-300 hover:translate-y-[-2px] hover:shadow-lg relative z-10',
      text: 'text-gray-800 font-medium',
      border: 'border border-emerald-100 border-opacity-30',
      animation: 'nature-message-appear 0.5s ease-out forwards'
    },
    user: {
      background: 'bg-emerald-600 backdrop-blur transform transition-all duration-300 hover:translate-y-[-2px] hover:shadow-lg relative z-10',
      text: 'text-gray-800 font-medium',
      border: 'border border-emerald-300 border-opacity-30',
      animation: 'nature-message-appear 0.5s ease-out forwards'
    }
  },
  typingIndicator: {
    container: 'bg-white/90 backdrop-blur relative z-10',
    dots: 'bg-emerald-600',
    animation: 'nature-typing-bounce 1.4s infinite ease-in-out'
  },
  footer: {
    text: 'text-gray-700 font-medium',
    link: 'text-emerald-600 hover:text-emerald-700 font-medium hover:underline',
    background: 'bg-white/90 backdrop-blur-md relative z-10',
    border: 'border-t border-white border-opacity-20'
  },
  animations: {
    '@keyframes nature-message-appear': {
      '0%': {
        transform: 'translateY(10px)',
        opacity: 0
      },
      '100%': {
        transform: 'translateY(0)',
        opacity: 1
      }
    },
    '@keyframes nature-typing-bounce': {
      '0%, 80%, 100%': {
        transform: 'scale(0.6)'
      },
      '40%': {
        transform: 'scale(1)'
      }
      }
    },
  effects: {
    natureMorphism: {
      base: 'backdrop-filter backdrop-blur-lg bg-opacity-70',
      hover: 'hover:bg-opacity-80 hover:backdrop-blur-xl transition-all duration-300',
      active: 'active:bg-opacity-90 active:backdrop-blur-2xl',
      border: 'border border-emerald-100 border-opacity-20'
    }
  },
  decorations: {
    leaf: {
      position: 'absolute',
      width: '20px',
      height: '20px',
      backgroundImage: "url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"%3E%3Cpath fill=\"%23059669\" d=\"M12,2C17.5,2 22,6.5 22,12C22,17.5 17.5,22 12,22C6.5,22 2,17.5 2,12C2,6.5 6.5,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4M12,6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18C8.69,18 6,15.31 6,12C6,8.69 8.69,6 12,6Z\"/%3E%3C/svg%3E')",
      opacity: 0.2,
      animation: 'nature-leaf-fall 8s linear infinite, nature-leaf-sway 4s ease-in-out infinite',
      top: 'var(--leaf-top, 0)',
      left: 'var(--leaf-left, 50%)',
      zIndex: 1
    },
    fallingLeaves: {
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none',
      overflow: 'hidden'
    },
    vines: {
      position: 'absolute',
      inset: 0,
      backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(5,150,105,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 30%, rgba(5,150,105,0.1) 0%, transparent 50%)',
      animation: 'nature-vines 15s ease infinite'
    }
  },
  background: {
    container: {
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      backgroundColor: 'bg-emerald-50',
      background: 'linear-gradient(to bottom, rgba(167, 243, 208, 0.2), rgba(110, 231, 183, 0.1))'
    },
    vineLeft: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '30%',
      height: '100%',
      backgroundImage: 'radial-gradient(circle at 0% 50%, rgba(5,150,105,0.1) 0%, transparent 70%)',
      animation: 'nature-vines 20s ease infinite'
    },
    vineRight: {
      position: 'absolute',
      right: 0,
      top: 0,
      width: '30%',
      height: '100%',
      backgroundImage: 'radial-gradient(circle at 100% 30%, rgba(5,150,105,0.1) 0%, transparent 70%)',
      animation: 'nature-vines 25s ease infinite reverse'
    }
  }
}; 